import React from 'react'
import SuperUserSettingsPageUI from '../../../templates/SuperUserSettingsPageUI'
import PageTitleUI from '../../../widgets/output/PageTitleUI'
import './LoanTypeAndEventMappingPage.css'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const LoanTypeAndEventMappingPageUI = (props) => {
  const { 
    context, 
    loanTypes = [],
    mappings = [], 
    loading, 
    error, 
    activeTab,
    activeSubType,
    onTabChange,
    onSubTypeChange,
    onEditClick 
  } = props;

  return (
    <SuperUserSettingsPageUI
      context={context}
      headerText="Loan Type and Event Mapping"
      page="loanTypeAndEventMapping"
    >
      <div className="t_content_section">
        <div className="t_content_section_header">
          <PageTitleUI context={context} titleText="Loan Type and Event Mapping" />
        </div>
                
        <div className="t_content_section_body">
          {/* Loan Types Tabs */}
          <div className="loan-types-tabs">
            {Array.isArray(loanTypes) && loanTypes.map((type, index) => (
              <div 
                key={index}
                className={`loan-type-tab ${activeTab === (type && type.name) ? 'active' : ''}`}
                onClick={() => onTabChange(type && type.name)}
              >
                {type && type.name}
              </div>
            ))}
          </div>
          
          {/* Sub Type Filter */}
          <div className="loan-types-filter">
            <label htmlFor="subtype-filter">Loan Subtype:</label>
            <select 
              id="subtype-filter" 
              value={activeSubType} 
              onChange={(e) => onSubTypeChange(e.target.value)}
            >
              <option value="All">All</option>
              {Array.isArray(loanTypes) && loanTypes.find(type => type && type.name === activeTab) && 
               Array.isArray(loanTypes.find(type => type && type.name === activeTab).subTypes) && 
               loanTypes.find(type => type && type.name === activeTab).subTypes.map(subType => (
                <option key={subType} value={subType}>{subType}</option>
              ))}
            </select>
          </div>

          {/* {loading && (
            <div className="g_center g_m_top_100">
              <div className="g_loader"></div>
            </div>
          )} */}
          {loading && <SpinnerComponentUI />}
          
          {error && (
            <div className="g_error g_m_top_50">
              {error}
            </div>
          )}
          
          {!loading && !error && (!mappings || mappings.length === 0) && (
            <div className="g_center g_m_top_100">
              <p className="g_muted">No mappings found for this loan type.</p>
            </div>
          )}
          
          {!loading && !error && mappings && mappings.length > 0 && (
            <div className="mapping-table">
              <div className="mapping-table-head">
                <div className="mapping-row">
                  <div className="mapping-cell">Sub Type</div>
                  <div className="mapping-cell">Category</div>
                  <div className="mapping-cell">Event Name</div>
                  <div className="mapping-cell">Sequence</div>
                  <div className="mapping-cell">WhatsApp Template Id</div>
                  <div className="mapping-cell">Email Template Id</div>
                  <div className="mapping-cell">Positive WhatsApp Template Id</div>
                  <div className="mapping-cell">Negative WhatsApp Template Id</div>
                  <div className="mapping-cell">Positive Email Template Id</div>
                  <div className="mapping-cell">Negative Email Template Id</div>
                  <div className="mapping-cell">Status</div>
                  <div className="mapping-cell">Edit</div>
                </div>
              </div>
              <div className="mapping-table-body">
                {Array.isArray(mappings) && mappings.map(mapping => (
                  <div key={mapping.id} className="mapping-row">
                    <div className="mapping-cell">{mapping.subType}</div>
                    <div className="mapping-cell">{mapping.category}</div>
                    <div className="mapping-cell">{mapping.eventName}</div>
                    <div className="mapping-cell">{mapping.sequence}</div>
                    <div className="mapping-cell">{mapping.whatsappTemplateId}</div>
                    <div className="mapping-cell">{mapping.emailTemplateId}</div>
                    <div className="mapping-cell">{mapping.positiveWhatsappTemplateId}</div>
                    <div className="mapping-cell">{mapping.negativeWhatsappTemplateId}</div>
                    <div className="mapping-cell">{mapping.positiveEmailTemplateId}</div>
                    <div className="mapping-cell">{mapping.negativeEmailTemplateId}</div>
                    <div className="mapping-cell">
                      <span className={`status-tag ${mapping.isEnabled ? 'active' : 'inactive'}`}>{mapping.isEnabled ? 'Active' : 'Inactive'}</span>
                    </div>
                    <div className="mapping-cell">
                      <span className="icon icon-pencil g_link_2" onClick={(e) => onEditClick(mapping)} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </SuperUserSettingsPageUI>
  )
}

export default LoanTypeAndEventMappingPageUI
